import { render } from "./MarcheDescription.vue?vue&type=template&id=5c89eae4"
import script from "./MarcheDescription.vue?vue&type=script&lang=js"
export * from "./MarcheDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__